export default {
  /**
   * Get a token from a local storage.
   */
  getToken() {
    return localStorage.getItem('token');
  },

  /**
   * Get token expiration date.
   */
  getTokenExpiration() {
    return localStorage.getItem('token_expire');
  },

  /**
   * Save token in a local storage.
   * @param token
   * @param expire
   */
  setToken(token, expire) {
    localStorage.setItem('token', token);
    localStorage.setItem('token_expire', expire);
  },

  /**
   * Remove a token
   */
  removeToken() {
    localStorage.removeItem('token');
    localStorage.removeItem('token_expire');
  },
};
